import { useTranslation } from 'react-i18next';

import { TranslationNamespace } from 'i18n';
import { orderRequisitesUtils } from 'utils';

import { QrCode } from './QrCode';

interface Props {
  qrCodeUrl?: string;
  paymentLink?: string;
  bankName?: string;
}

export const QrCodeWrapper: React.FC<Props> = ({
  qrCodeUrl,
  paymentLink,
  bankName,
}) => {
  const { t } = useTranslation(TranslationNamespace.Common, {
    keyPrefix: 'components.payment_details',
  });

  if (qrCodeUrl) {
    return (
      <div className="tw-w-full md:tw-p-1">
        <img
          className="tw-w-full"
          src={qrCodeUrl}
          alt={t('qr_code.placeholder')}
        />
      </div>
    );
  }

  if (paymentLink) {
    return (
      <div className="tw-w-full tw-bg-white tw-border-1 tw-border-solid tw-border-gray-400 tw-rounded-xl tw-px-4 tw-pt-4 tw-pb-2">
        <div className="tw-mb-4 tw-text-center tw-text-lg">
          <div className="tw-mr-3">
            <span className="tw-font-normal">{`${t(
              'payment_link.label',
            )}: `}</span>
            <a
              href={paymentLink}
              target="_blank"
              rel="noopener noreferrer"
              className="tw-break-all tw-text-blue-600 tw-underline hover:tw-text-blue-800 tw-font-semibold tw-transition-colors"
            >
              {orderRequisitesUtils.formatPaymentLink(paymentLink)}
            </a>
          </div>
        </div>
        <QrCode
          data={paymentLink}
          {...(bankName && { title: t('qr_code.title', { bankName }) })}
        />
      </div>
    );
  }

  return null;
};
